/* unplugin-vue-components disabled */import { render } from "./VoiceOver.vue?vue&type=template&id=4802db74&scoped=true&ts=true"
import script from "./VoiceOver.vue?vue&type=script&lang=ts"
export * from "./VoiceOver.vue?vue&type=script&lang=ts"

import "./VoiceOver.vue?vue&type=style&index=0&id=4802db74&lang=scss"
import "./VoiceOver.vue?vue&type=style&index=1&id=4802db74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4802db74"]])

export default __exports__